<template>
  <span>
    <b-toast id="max-3-votes" no-close-button b-toaster-top-right variant="warning" :solid="true">
      <strong>
        {{ $t("max-3-votes") }}
      </strong>
    </b-toast>
    <span v-if="$store.state.main.game.actionPlanActivated">
      <h3 style="page-break-before: always" id="actionplan">
        {{ $t("action-plan") }}
      </h3>
    </span>
    <span
      class="noprint"
      v-if="!$store.state.main.game.actionPlanActivated && $store.getters.getIsFacilitator"
    >
      <card shadow>
        <span class="button-example">
          <font-awesome-icon transform="right-6" icon="lightbulb" />
          &nbsp;
        </span>
        <small>
          &nbsp;
          {{ $t("action-plan-info-for-facilitator") }}
        </small>
      </card>
      <br />
      <base-button style="white-space: normal;" type="success" v-on:click="activateActionPlan()">{{
        $t("activate-action-plan-only-facilitator")
      }}</base-button>
    </span>
    <span
      v-if="
        $store.state.main.game.actionPlanActivated &&
          !$store.state.main.game.actionPlanVotingFinished
      "
    >
      <span class="noprint">
        <card shadow>
          <span class="button-example">
            <font-awesome-icon transform="right-6" icon="lightbulb" />
            &nbsp;
          </span>
          <small>
            &nbsp;
            {{ $t("action-plan-voting-info") }}
          </small>
        </card>
      </span>
      <br />
      <div v-if="$store.getters.getIsFacilitator" class="noprint action-plan-ideas-toggle">
        <label class="action-plan-ideas-toggle__label">
          <base-switch
            :value="showDevelopmentIdeas"
            @input="setShowDevelopmentIdeas"
          />
          <span>{{ $t("show-development-ideas") }}</span>
        </label>
      </div>
      <div v-for="aCase in getCases" :key="aCase.caseNumber">
        <base-button
          :outline="!hasVoted(aCase.caseNumber)"
          :cursor="$store.state.main.thisPlayerId ? 'initial' : 'auto'"
          :disabled="!$store.state.main.thisPlayerId || (votesCounted === 3 && !hasVoted(aCase.caseNumber))"
          :style="{
            textAlign: 'left',
            margin: '3px',
            pointerEvents: (! $store.state.main.thisPlayerId || (votesCounted === 3 && !hasVoted(aCase.caseNumber))) ? 'none' : undefined
          }"
          v-on:click="handleVoteAndBlur(aCase.caseNumber, $event)"
          @touchend.native.passive="handleButtonTouchEnd(aCase.caseNumber, $event)"
          type="primary"
        >
          <span style="color: black;">{{ aCase.caseNumber }}. {{ getCaseName(aCase) }}</span>
          <span style="color: black; font-weight: 500;" v-if="$store.state.main.game.enableSurvey">
            <br />
            ({{ $t("level") }}: {{ survey1Averages[aCase.caseNumber] }} {{ $t("importance") }}:
            {{ survey2Averages[aCase.caseNumber] }} {{ $t("difference") }}:
            <span :style="getDifferenceStyle(aCase.caseNumber)">
              {{ countDifference(aCase.caseNumber) }}
            </span>
            )
          </span>
          <br />
          <ul
            v-if="showDevelopmentIdeas"
            style="color: black; font-weight: 400; text-transform: none; white-space: normal;"
            v-for="suggestion in getSuggestions(aCase.caseNumber)"
            :key="suggestion.id"
          >
            <li>{{ suggestion.suggestion }}</li>
          </ul>
        </base-button>
      </div>
      <VotingWaitingPlayers />
      <Robot />
    </span>
    <span
      v-if="
        $store.state.main.game.actionPlanActivated &&
          $store.state.main.game.actionPlanVotingFinished
      "
    >
      <span v-if="!isLocked" class="noprint">
        <card shadow>
          <span class="button-example">
            <font-awesome-icon transform="right-6" icon="lightbulb" />
            &nbsp;
          </span>
          <small>
            &nbsp;
            {{ $t("action-plan-deadline-owner-info") }}
          </small>
        </card>
        <br />
      </span>
      <div v-if="$store.getters.getIsFacilitator" class="noprint action-plan-ideas-toggle">
        <label class="action-plan-ideas-toggle__label">
          <base-switch
            :value="showDevelopmentIdeas"
            @input="setShowDevelopmentIdeas"
          />
          <span>{{ $t("show-development-ideas") }}</span>
        </label>
      </div>
      <div v-for="aCase in getCasesSortedByVotes" :key="aCase.caseNumber">
        <card shadow :style="getCardStyle(aCase.caseNumber)">
          <h6>
            <strong
              >{{ aCase.caseNumber }}. {{ getCaseName(aCase) }} ({{ $t("votes") }}:
              {{ numberOfVotes(aCase.caseNumber) }})</strong
            >
          </h6>
          <span v-if="$store.state.main.game.enableSurvey">
            {{ $t("level") }}: {{ survey1Averages[aCase.caseNumber] }} {{ $t("importance") }}:
            {{ survey2Averages[aCase.caseNumber] }} {{ $t("difference") }}:
            <span :style="getDifferenceStyle(aCase.caseNumber)">{{
              countDifference(aCase.caseNumber)
            }}</span>
            <br />
          </span>
          <table
            class="table table-striped table-sm"
            v-if="showDevelopmentIdeas && getSuggestions(aCase.caseNumber).length > 0"
          >
            <thead>
              <tr class="d-flex">
                <th scope="col" class="col-8">
                  {{ $t("development-suggestion") }}
                </th>
                <th scope="col" class="col-2">
                  {{ $t("owner") }}
                </th>
                <th clascopess="col" class="col-2">
                  {{ $t("deadline") }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="d-flex" v-for="suggestion in getSuggestions(aCase.caseNumber)" :key="suggestion.id">
                <td class="col-8">
                  {{ suggestion.suggestion }}
                  <span class="noprint" v-if="showEditDeleteButtons(suggestion)">
                    <base-dropdown>
                      <base-button
                        slot="title"
                        size="sm"
                        type="secondary"
                        class="dropdown-toggle"
                      ></base-button>
                      <base-button
                        size="sm"
                        type="primary"
                        @click="editSuggestion(suggestion.id)"
                        >{{ $t("edit") }}</base-button
                      >
                      <base-button
                        size="sm"
                        type="warning"
                        @click="deleteSuggestion(suggestion.id)"
                        >{{ $t("delete") }}</base-button
                      >
                    </base-dropdown>
                  </span>
                </td>
                <td class="col-2">
                  <span v-if="isLocked">
                    {{ getOwnerName(suggestion.id) }}
                  </span>
                  <base-dropdown
                    class="noprint"
                    v-if="!$store.state.main.playerIsObserver && !isLocked"
                    @change="handleDropdownToggle(aCase.caseNumber, $event)"
                  >
                    <base-button slot="title" size="sm" type="secondary" class="dropdown-toggle">{{
                      getOwnerDropdownText(suggestion.id)
                    }}</base-button>
                    <div v-for="player in $store.getters.getPlayers" :key="player.id">
                      <a class="dropdown-item" @click="setOwner(suggestion.id, player.id)">{{
                        player.nick_name
                      }}</a>
                    </div>
                  </base-dropdown>
                </td>
                <td class="col-2">
                  <span v-if="isLocked">
                    {{ getDeadline(suggestion.id) }}
                  </span>
                  <base-input v-if="!isLocked" style="margin-bottom: 0px;">
                    <flat-picker
                      slot-scope="{ focus, blur }"
                      style="padding: 0px !important; height: 30px;"
                      @on-open="focus"
                      @on-close="blur"
                      @input="setDeadline(suggestion.id, $event)"
                      :config="{ allowInput: true }"
                      class="form-control datepicker"
                      :value="getDeadline(suggestion.id)"
                    >
                    </flat-picker>
                  </base-input>
                </td>
              </tr>
            </tbody>
          </table>
          <base-button
            v-if="showAddSuggestionButton(aCase.caseNumber)"
            size="sm"
            type="primary"
            class="noprint"
            @click="addSuggestion(aCase)"
            >{{ $t("add-new-suggestion") }}</base-button
          >
          <div class="text-center">
            <base-button
              size="sm"
              v-if="showMoveDiscussionToNextCaseButton(aCase.caseNumber)"
              style="white-space: normal; margin: 4px;"
              type="success"
              v-on:click="moveDiscussion(aCase.caseNumber)"
              >{{ getMoveDiscussionButtonTitle(aCase.caseNumber) }}</base-button
            >
          </div>
        </card>
      </div>
      <br />
      <div class="text-center">
        <span v-if="!$store.state.main.game.actionPlanLocked && $store.getters.getIsFacilitator">
          <base-button
            size="sm"
            class="noprint"
            style="white-space: normal; margin: 2px;"
            type="success"
            v-on:click="lockActionPlan()"
            >{{ $t("lock-action-plan-only-facilitator") }}</base-button
          >
        </span>
        <span v-if="$store.state.main.game.actionPlanLocked && $store.getters.getIsFacilitator">
          <base-button
            size="sm"
            class="noprint"
            style="white-space: normal; margin: 2px;"
            type="success"
            v-on:click="unlockActionPlan()"
            >{{ $t("unlock-action-plan-only-facilitator") }}</base-button
          >
        </span>
      </div>
    </span>
    <span
      v-if="
        $store.state.main.game.actionPlanActivated &&
          !$store.state.main.game.actionPlanVotingFinished &&
          $store.getters.getIsFacilitator
      "
    >
      <base-button style="white-space: normal;" type="success" v-on:click="finishVoting()">{{
        $t("finish-voting-only-facilitator")
      }}</base-button>
    </span>
  </span>
</template>

<script>
import Swal from "sweetalert2";
import {
  updateGameActionPlanActivated,
  sendActionPlanVote,
  deleteActionPlanVote,
  updateGameActionPlanLocked,
  updateGameActionPlanCaseBeingDiscussed,
  updateGameActionPlanEndVoting,
  updateGameActionPlanShowDevelopmentIdeas,
  editSuggestion,
  sendSuggestion,
  deleteSuggestion
} from "@/services/APIService";
import VotingWaitingPlayers from "@/components/ActionPlan/VotingWaitingPlayers.vue";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Robot from "@/components/Robot.vue";
const sortby = require("lodash.sortby");
const VueScrollTo = require("vue-scrollto");

export default {
  props: ["survey1Averages", "survey2Averages"],
  data: function() {
    return {
      votingTimer: 0,
      owners: [],
      deadlines: [],
      caseWithOpenDropdown: null
    };
  },
  components: {
    VotingWaitingPlayers,
    flatPicker,
    Robot
  },
  created() {},
  watch: {
    isActivated: {
      handler(newData, oldData) {
        if (this.$store.getters.getIsFacilitator) {
          return;
        }
        this.$store.dispatch("log", "isActivated watcher");
        if (newData && !oldData) {
          this.$nextTick(() => {
            VueScrollTo.scrollTo("#actionplan");
          });
        }
      }
    }
  },
  computed: {
    isActivated() {
      return this.$store.state.main.game.actionPlanActivated;
    },
    isLocked() {
      return this.$store.state.main.game.actionPlanLocked;
    },
    getCases() {
      if (this.$store.state.main.game.simulationType === "classic") {
        return this.$store.getters.getCasesInCurrentLocale;
      } else {
        return this.$store.getters.getRPSCasesInCurrentLocale;
      }
    },
    getCasesSortedByVotes() {
      let cases = [];
      if (this.$store.state.main.game.simulationType === "classic") {
        cases = this.$store.getters.getCasesInCurrentLocale;
      } else {
        cases = this.$store.getters.getRPSCasesInCurrentLocale;
      }
      const numberOfCases = cases.length;
      const votes = [];
      for (let caseNumber = 1; caseNumber <= numberOfCases; caseNumber++) {
        const caseVotes = this.$store.getters.getActionPlanVotesByCaseNumber(caseNumber);
        votes.push({ caseNumber: caseNumber, votes: caseVotes.length });
      }
      votes.sort((a, b) => b.votes - a.votes);
      const orderedCases = [];
      for (let i = 0; i < votes.length; i++) {
        const aCase = cases.find(c => (c.case && c.case.case_number === votes[i].caseNumber) || (c.rpsCase && c.rpsCase.case_number === votes[i].caseNumber) || c.caseNumber === votes[i].caseNumber);
        if (aCase) {
            orderedCases.push(aCase);
        }
      }
      return orderedCases;
    },
    votesCounted() {
      if (!this.$store.state.main.thisPlayerId) return 0;
      return this.$store.getters.getActionPlanVotesByPlayer(
        this.$store.state.main.thisPlayerId
      ).length;
    },
    showDevelopmentIdeas() {
      return this.$store.state.main.game.actionPlanShowDevelopmentIdeas;
    }
  },
  methods: {
    handleDropdownToggle(caseNumber, isOpen) {
      if (isOpen) {
        this.caseWithOpenDropdown = caseNumber;
      } else {
        if (this.caseWithOpenDropdown === caseNumber) {
          this.caseWithOpenDropdown = null;
        }
      }
    },
    handleVoteAndBlur(caseNumber, event) {
      this.vote(caseNumber);
      const buttonElement = event.currentTarget;
      this.$nextTick(() => {
        if (buttonElement && typeof buttonElement.blur === 'function') {
          buttonElement.blur();
        }
      });
    },
    handleButtonTouchEnd(caseNumber, event) {
      const buttonElement = event.currentTarget;
      if (buttonElement && typeof buttonElement.blur === 'function') {
        buttonElement.blur();
      }
    },
    vote(caseNumber) {
      if (this.votingTimer && Date.now() - this.votingTimer < 200) {
        return;
      }
      this.votingTimer = Date.now();
      const vote = this.$store.getters.getActionPlanVoteByCaseNumberAndPlayer(
        caseNumber,
        this.$store.state.main.thisPlayerId
      );
      let aCaseData = null;
      let rpsCaseData = null;
      if (this.$store.getters.getIsClassic) {
        aCaseData = this.$store.getters.getCaseByCaseNumber(caseNumber).case;
      } else {
        rpsCaseData = this.$store.getters.getRPSCaseByCaseNumber(caseNumber).rpsCase;
      }
      if (vote) {
        this.$store.commit({
          type: "deleteOneActionPlanVote",
          case: aCaseData,
          rps_case: rpsCaseData,
          player: this.$store.state.main.thisPlayerId
        });
        deleteActionPlanVote(vote.id, this.$store.state.main.game.gameCode);
      } else {
        if (this.votesCounted < 3) {
            this.$store.commit({
              type: "setOneActionPlanVote",
              case: aCaseData,
              rps_case: rpsCaseData,
              player: this.$store.state.main.thisPlayerId,
              case_number: caseNumber
            });
            sendActionPlanVote(
              this.$store.state.main.game.id,
              this.$store.state.main.thisPlayerId,
              aCaseData,
              rpsCaseData,
              this.$store.state.main.game.gameCode
            );
        } else {
            this.$bvToast.show('max-3-votes');
        }
      }
    },
    getCaseName(aCase) {
      if (this.$store.state.main.game.simulationType === "classic") {
        return aCase.shortName;
      } else {
        return aCase.title;
      }
    },
    numberOfVotes(caseNumber) {
      return this.$store.getters.getActionPlanVotesByCaseNumber(caseNumber).length;
    },
    hasVoted(caseNumber) {
      if (!this.$store.state.main.thisPlayerId) return false;
      const vote = this.$store.getters.getActionPlanVoteByCaseNumberAndPlayer(
        caseNumber,
        this.$store.state.main.thisPlayerId
      );
      return !!vote;
    },
    activateActionPlan() {
      updateGameActionPlanActivated(
        this.$store.state.main.game.id,
        this.$store.state.main.game.gameCode,
        true
      );
      this.setShowDevelopmentIdeas(true);
      if (event && event.currentTarget && typeof event.currentTarget.blur === 'function') {
        event.currentTarget.blur();
      }
    },
    lockActionPlan() {
      updateGameActionPlanLocked(
        this.$store.state.main.game.id,
        this.$store.state.main.game.gameCode,
        true
      );
      if (event && event.currentTarget && typeof event.currentTarget.blur === 'function') {
        event.currentTarget.blur();
      }
    },
    unlockActionPlan() {
      updateGameActionPlanLocked(
        this.$store.state.main.game.id,
        this.$store.state.main.game.gameCode,
        false
      );
      if (event && event.currentTarget && typeof event.currentTarget.blur === 'function') {
        event.currentTarget.blur();
      }
    },
    finishVoting() {
      const sortedCases = this.getCasesSortedByVotes;
      if (sortedCases && sortedCases.length > 0 ) {
        const firstCase = sortedCases[0];
        let firstCaseCaseNumber;
        if (firstCase) {
            if (firstCase.caseNumber !== undefined) {
                firstCaseCaseNumber = firstCase.caseNumber;
            } else if (firstCase.case && firstCase.case.case_number !== undefined) {
                firstCaseCaseNumber = firstCase.case.case_number;
            } else if (firstCase.rpsCase && firstCase.rpsCase.case_number !== undefined) {
                firstCaseCaseNumber = firstCase.rpsCase.case_number;
            }
        }
        if (firstCaseCaseNumber !== undefined) {
            updateGameActionPlanEndVoting(
              this.$store.state.main.game.id,
              this.$store.state.main.game.gameCode,
              firstCaseCaseNumber
            );
        } else {
            console.warn("finishVoting: Could not determine caseNumber for the first sorted case.", firstCase);
        }
      } else {
          console.warn("finishVoting: No cases sorted by votes found.");
      }
      if (event && event.currentTarget && typeof event.currentTarget.blur === 'function') {
        event.currentTarget.blur();
      }
    },
    getSuggestions(caseNumber) {
      return this.$store.getters.getSuggestionsByCaseNumber(caseNumber);
    },
    setShowDevelopmentIdeas(showDevelopmentIdeas) {
      if (typeof showDevelopmentIdeas !== "boolean") {
        return;
      }
      if (showDevelopmentIdeas === this.showDevelopmentIdeas) {
        return;
      }
      this.$store.commit("setActionPlanShowDevelopmentIdeas", showDevelopmentIdeas);
      updateGameActionPlanShowDevelopmentIdeas(
        this.$store.state.main.game.id,
        this.$store.state.main.game.gameCode,
        showDevelopmentIdeas
      );
    },
    getDeadline(id) {
      const suggestion = this.$store.getters.getSuggestionById(id);
      return suggestion ? suggestion.deadline : null;
    },
    setOwner(id, playerId) {
      const s = this.$store.getters.getSuggestionById(id);
      if (s) {
        editSuggestion(id, s.suggestion, playerId, s.deadline, this.$store.state.main.game.gameCode);
      }
    },
    setDeadline(id, eventData) {
      const s = this.$store.getters.getSuggestionById(id);
      if (s) {
        editSuggestion(id, s.suggestion, s.owner, eventData, this.$store.state.main.game.gameCode);
      }
    },
    getOwnerDropdownText(id) {
      const s = this.$store.getters.getSuggestionById(id);
      if (s && s.owner) {
        const player = this.$store.getters.getPlayerById(s.owner);
        return player ? player.nick_name : this.$t("select-owner");
      } else {
        return this.$t("select-owner");
      }
    },
    addSuggestion(aCaseInput) {
      Swal.fire({
        text: this.$t("add-new-suggestion"),
        input: "text",
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonText: this.$t("send"),
        cancelButtonText: this.$t("cancel")
      }).then(result => {
        if (result.value) {
          const classicCaseData = (aCaseInput && this.$store.state.main.game.simulationType === 'classic') ? (aCaseInput.case || (this.$store.getters.getCaseByCaseNumber(aCaseInput.caseNumber) || {}).case) : null;
          const rpsCaseData = (aCaseInput && this.$store.state.main.game.simulationType !== 'classic') ? (aCaseInput.rpsCase || (this.$store.getters.getRPSCaseByCaseNumber(aCaseInput.caseNumber) || {}).rpsCase) : null;
          sendSuggestion(
            this.$store.state.main.game.id,
            this.$store.state.main.thisPlayerId,
            result.value,
            classicCaseData,
            rpsCaseData,
            this.$store.state.main.game.gameCode
          );
        }
      });
    },
    editSuggestion(id) {
      const s = this.$store.getters.getSuggestionById(id);
      if (!s) return;
      Swal.fire({
        text: this.$t("edit-suggestion"),
        input: "text",
        inputValue: s.suggestion,
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonText: this.$t("send"),
        cancelButtonText: this.$t("cancel")
      }).then(result => {
        if (result.value) {
          editSuggestion(
            id,
            result.value,
            s.owner,
            s.deadline,
            this.$store.state.main.game.gameCode
          );
        }
      });
    },
    deleteSuggestion(id) {
      deleteSuggestion(id, this.$store.state.main.game.gameCode);
    },
    showEditDeleteButtons(suggestion) {
      if (this.isLocked) {
        return false;
      }
      if (this.$store.getters.getIsFacilitator) {
        return true;
      }
      if (suggestion.player === this.$store.state.main.thisPlayerId) {
        return true;
      }
      return false;
    },
    countDifference(caseNumber) {
      if (this.survey1Averages && this.survey1Averages[caseNumber] !== undefined &&
          this.survey2Averages && this.survey2Averages[caseNumber] !== undefined) {
        const diff = this.survey1Averages[caseNumber] - this.survey2Averages[caseNumber];
        return Math.round(diff * 10) / 10;
      }
      return "?";
    },
    getOwnerName(id) {
      const s = this.$store.getters.getSuggestionById(id);
      if (s && s.owner) {
        const player = this.$store.getters.getPlayerById(s.owner);
        return player ? player.nick_name : "";
      } else {
        return "";
      }
    },
    getCardStyle(caseNumber) {
      const baseStyle = "position: relative;";
      let zIndex = 1;
      let currentOpacityStyle = "";

      if (this.caseWithOpenDropdown === caseNumber) {
        zIndex = 15;
        return `${baseStyle} z-index: ${zIndex} !important;`;
      }

      if (this.$store.state.main.game.actionPlanCaseBeingDiscussed === caseNumber) {
        zIndex = 10;
        return `${baseStyle} z-index: ${zIndex} !important; border: 3px solid; border-color: #2dce89 !important;`;
      }

      if (this.$store.state.main.game.actionPlanActivated) {
        if (this.$store.state.main.game.actionPlanCaseBeingDiscussed && this.$store.state.main.game.actionPlanCaseBeingDiscussed !== caseNumber) {
          zIndex = 5;
          currentOpacityStyle = "opacity: 0.5 !important;";
        } else if (!this.$store.state.main.game.actionPlanCaseBeingDiscussed) {
          zIndex = 5;
          currentOpacityStyle = "opacity: 0.5 !important;";
        }
      }
      return `${baseStyle} z-index: ${zIndex} !important; ${currentOpacityStyle}`;
    },
    showMoveDiscussionToNextCaseButton(caseNumber) {
      return (
        this.$store.getters.getIsFacilitator &&
        this.$store.state.main.game.actionPlanCaseBeingDiscussed === caseNumber &&
        !this.$store.state.main.game.actionPlanLocked
      );
    },
    showAddSuggestionButton(caseNumber) {
      if (this.$store.state.main.playerIsObserver || this.isLocked) {
        return false;
      }
      if (!this.$store.state.main.game.actionPlanCaseBeingDiscussed) {
        return true;
      }
      if (this.$store.state.main.game.actionPlanCaseBeingDiscussed !== caseNumber) {
        return false;
      }
      return true;
    },
    getMoveDiscussionButtonTitle(caseNumber) {
      const sortedCases = this.getCasesSortedByVotes;
      let i = 0;
      for (; i < sortedCases.length; i++) {
        const currentCase = sortedCases[i];
        const currentCaseNum = (currentCase.case && currentCase.case.case_number) || (currentCase.rpsCase && currentCase.rpsCase.case_number) || currentCase.caseNumber;
        if (currentCaseNum === caseNumber) {
          break;
        }
      }
      if (i < sortedCases.length - 1) {
        return this.$t("move-discussion-to-next-case-only-facilitator");
      }
      return this.$t("remove-discussion-indicator-only-facilitator");
    },
    moveDiscussion(caseNumber) {
      const sortedCases = this.getCasesSortedByVotes;
      let i = 0;
      for (; i < sortedCases.length; i++) {
        const currentCase = sortedCases[i];
        const currentCaseNum = (currentCase.case && currentCase.case.case_number) || (currentCase.rpsCase && currentCase.rpsCase.case_number) || currentCase.caseNumber;
        if (currentCaseNum === caseNumber) {
          break;
        }
      }
      let nextCaseNumToDiscuss = 0;
      if (i < sortedCases.length - 1) {
        const nextSortedCase = sortedCases[i+1];
        if (nextSortedCase) {
            nextCaseNumToDiscuss = (nextSortedCase.case && nextSortedCase.case.case_number) || (nextSortedCase.rpsCase && nextSortedCase.rpsCase.case_number) || nextSortedCase.caseNumber;
        }
      }
      updateGameActionPlanCaseBeingDiscussed(
        this.$store.state.main.game.id,
        this.$store.state.main.game.gameCode,
        nextCaseNumToDiscuss
      );
    },
    getDifferenceStyle(caseNumber) {
      if (this.countDifference(caseNumber) < 0) {
        return "color: red;";
      } else {
        return "";
      }
    }
  }
};
</script>

<i18n>
  {
    "en": {
      "activate-action-plan-only-facilitator":  "Activate action plan (button only shown to facilitator)",
      "action-plan-info-for-facilitator": "Optional: Action plan helps in facilitating discussion to agree on concrete next steps after the simulation. First the players vote on the most important topics. After voting they create actionable items with owners and deadlines. If you activate the action plan, it opens a voting to participants.",
      "action-plan-voting-info": "Please choose 3 topics you think are the most topical to discuss now. After voting the topics will be ordered based on the votes.",
      "action-plan-deadline-owner-info": "Topics are sorted based on the votes. Players can edit and delete development suggestions they have submitted. The active case under discussion is highlighted. When ready, the facilitator will highlight the next case.",
      "finish-voting-only-facilitator": "Finish voting (button only shown to facilitator)",
      "lock-action-plan-only-facilitator": "Lock action plan to finish editing (button only shown to facilitator)",
      "unlock-action-plan-only-facilitator": "Unlock action plan for editing (button only shown to facilitator)",
      "move-discussion-to-next-case-only-facilitator": "Move discussion to next topic (button only shown to facilitator)",
      "remove-discussion-indicator-only-facilitator": "End discussion (button only shown to facilitator)",
      "add-new-suggestion": "Add development suggestion",
      "development-suggestion": "Development suggestion",
      "cancel": "Cancel",
      "send": "Send",
      "max-3-votes": "Maximum number of votes is 3.",
      "action-plan": "Action Plan",
      "owner": "Owner",
      "deadline": "Deadline",
      "select-owner": "Select",
      "edit": "edit",
      "delete": "delete",
      "level": "level",
      "importance": "importance",
      "difference": "difference",
      "votes": "votes",
      "edit-suggestion": "Edit development suggestion",
      "show-development-ideas": "Show development ideas written during the simulation to participants"
    },
    "fi": {
      "activate-action-plan-only-facilitator":  "Aktivoi kehityssuunnitelma (painike näytetään vain pelinjohtajalle)",
      "action-plan-info-for-facilitator": "Valinnainen: Kehityssuunnitelma auttaa käymään keskustelua, jossa sovitaan konkreettisista tehtävistä simulaation jälkeen. Pelaajat äänestävät ensin tärkeimmistä aiheista. Äänestyksen jälkeen he luovat tehtäviä, joilla on omistajat ja määräajat. Kun aktivoit toimintasuunnitelman, se avaa äänestyksen pelaajille.",
      "action-plan-voting-info": "Valitse kolme mielestäsi ajankohtaisinta aihetta. Äänestyksen jälkeen aiheet järjestetään äänten perusteella.",
      "action-plan-deadline-owner-info": "Aiheet lajitellaan äänten perusteella. Pelaajat voivat muokata ja poistaa lähettämiään kehitysehdotuksia. Keskustelun kohteena oleva aihe on korostettu. Kun keskustelu on valmis, pelinjohtaja siirtää keskustelun seuraavan aiheeseen.",
      "finish-voting-only-facilitator": "Päätä äänestys (painike näytetään vain pelinjohtajalle)",
      "lock-action-plan-only-facilitator": "Lukitse kehityssuunnitelma (painike näytetään vain pelinjohtajalle)",
      "unlock-action-plan-only-facilitator": "Avaa kehityssuunnitelma muokkausta varten (painike näytetään vain pelinjohtajalle)",
      "move-discussion-to-next-case-only-facilitator": "Siirrä keskustelu seuraavaan aiheeseen (painike näkyy vain pelinjohtajalle)",
      "remove-discussion-indicator-only-facilitator": "Keskustelun päättäminen (painike näytetään vain pelinjohtajalle)",
      "add-new-suggestion": "Lisää kehitysehdotus",
      "development-suggestion": "Kehitysehdotus",
      "cancel": "Peru",
      "send": "Lähetä",
      "max-3-votes": "Voit äänestää enintään kolmea aihetta.",
      "action-plan": "Kehityssuunnitelma",
      "owner": "Omistaja",
      "deadline": "Määräaika",
      "select-owner": "Valitse",
      "edit": "muokkaa",
      "delete": "poista",
      "level": "taso",
      "importance": "tärkeys",
      "difference": "erotus",
      "votes": "ääniä",
      "edit-suggestion": "Muokkaa",
      "show-development-ideas": "Näytä simulaation aikana kirjoitetut kehitysideat osallistujille"
    },
    "sv": {
      "activate-action-plan-only-facilitator":  "Aktivera handlingsplanen (knappen visas endast för facilitatorn)",
      "action-plan-info-for-facilitator": "Valfritt: Handlingsplan hjälper till att underlätta diskussionen för att komma överens om konkreta nästa steg efter simuleringen. Först röstar spelarna om de viktigaste frågorna. Efter omröstningen skapar de åtgärder med ägare och tidsfrister. Om du aktiverar handlingsplanen öppnas en omröstning för deltagarna.",
      "action-plan-voting-info": "Välj tre ämnen som du tycker är mest aktuella att diskutera nu. Efter omröstningen kommer ämnena att ordnas utifrån rösterna.",
      "action-plan-deadline-owner-info": "Ämnena sorteras utifrån rösterna. Spelare kan redigera och radera utvecklingsförslag som de har lämnat in. Det aktiva fallet som diskuteras är markerat. När det är klart kommer facilitatorn att lyfta fram nästa fall.",
      "finish-voting-only-facilitator": "Avsluta omröstningen (knappen visas endast för facilitatorn)",
      "lock-action-plan-only-facilitator": "Lås handlingsplanen för att avsluta redigeringen (knappen visas endast för facilitatorn)",
      "unlock-action-plan-only-facilitator": "Lås upp handlingsplanen för redigering (knappen visas endast för facilitatorn).",
      "move-discussion-to-next-case-only-facilitator": "Flytta diskussionen till nästa ämne (knappen visas endast för facilitatorn)",
      "remove-discussion-indicator-only-facilitator": "Avsluta diskussionen (knappen visas endast för facilitatorn)",
      "add-new-suggestion": "Lägg till utvecklingsförslag",
      "development-suggestion": "Utvecklingsförslag",
      "cancel": "Avbryta",
      "send": "Skicka",
      "max-3-votes": "Maximalt antal röster är 3.",
      "action-plan": "Handlingsplan",
      "owner": "Ägare",
      "deadline": "Tidsfrist",
      "select-owner": "Välj",
      "edit": "redigera",
      "delete": "radera",
      "level": "nivå",
      "importance": "vikt",
      "difference": "skillnad",
      "votes": "röster",
      "edit-suggestion": "Redigera",
      "show-development-ideas": "Visa under simuleringen skrivna utvecklingsidéer för deltagarna"
    },
    "de": {
      "activate-action-plan-only-facilitator":  "Aktivieren Sie den Aktionsplan (die Schaltfläche wird nur dem Moderator angezeigt)",
      "action-plan-info-for-facilitator": "Optional: Ein Aktionsplan hilft bei der Erleichterung der Diskussion, um sich auf konkrete nächste Schritte nach der Simulation zu einigen. Zunächst stimmen die Teilnehmer über die wichtigsten Themen ab. Nach der Abstimmung erstellen sie umsetzbare Punkte mit Verantwortlichen und Fristen. Wenn Sie den Aktionsplan aktivieren, wird den Teilnehmern eine Abstimmung angeboten.",
      "action-plan-voting-info": "Bitte wählen Sie 3 Themen, die Sie für die wichtigsten halten. Nach der Abstimmung werden die Themen anhand der Stimmen geordnet.",
      "action-plan-deadline-owner-info": "Die Themen werden nach der Anzahl der Stimmen sortiert. Spieler können von ihnen eingereichte Entwicklungsvorschläge bearbeiten und löschen. Der aktive Fall, der gerade diskutiert wird, wird hervorgehoben. Wenn Sie bereit sind, wird der Moderator den nächsten Fall hervorheben.",
      "finish-voting-only-facilitator": "Abstimmung beenden (Schaltfläche wird nur dem Moderator angezeigt)",
      "lock-action-plan-only-facilitator": "Aktionsplan sperren, um Bearbeitung abzuschließen (Schaltfläche wird nur dem Moderator angezeigt)",
      "unlock-action-plan-only-facilitator": "Aktionsplan zur Bearbeitung freischalten (Schaltfläche wird nur dem Moderator angezeigt)",
      "move-discussion-to-next-case-only-facilitator": "Diskussion zum nächsten Thema verschieben (Schaltfläche wird nur dem Moderator angezeigt)",
      "remove-discussion-indicator-only-facilitator": "Diskussion beenden (Schaltfläche wird nur dem Moderator angezeigt)",
      "add-new-suggestion": "Vorschlag für die Entwicklung hinzufügen",
      "development-suggestion": "Vorschlag für die Entwicklung",
      "cancel": "Abbrechen",
      "send": "Senden Sie",
      "max-3-votes": "Die maximale Anzahl der Stimmen beträgt 3.",
      "action-plan": "Aktionsplan",
      "owner": "Eigentümer",
      "deadline": "Deadline",
      "select-owner": "Wählen",
      "edit": "bearbeiten",
      "delete": "löschen",
      "level": "Wie gut geht es",
      "importance": "Bedeutung",
      "difference": "Unterschied",
      "votes": "Stimmen",
      "edit-suggestion": "Bearbeiten",
      "show-development-ideas": "Während der Simulation geschriebene Entwicklungsideen den Teilnehmern anzeigen"
    },
   "ko": {
      "activate-action-plan-only-facilitator":  "실행 계획 활성화(진행자에게만 버튼이 표시됨)",
      "action-plan-info-for-facilitator": "선택 사항: 실행 계획은 시뮬레이션 후 구체적인 다음 단계에 동의하기 위한 토론을 촉진하는 데 도움이 됩니다. 먼저 플레이어는 가장 중요한 주제에 투표합니다. 투표 후 소유자와 기한이 있는 실행 가능한 항목을 만듭니다. 실행 계획을 활성화하면 참가자에게 투표가 열립니다.",
      "action-plan-voting-info": "가장 중요하다고 생각하는 주제 3개를 선택해 주십시오. 투표 후 주제는 투표에 따라 정렬됩니다.",
      "action-plan-deadline-owner-info": "주제는 투표에 따라 정렬됩니다. 플레이어는 제출한 개발 제안을 수정하고 삭제할 수 있습니다. 논의 중인 활성 사례가 강조 표시됩니다. 준비가 되면 진행자가 다음 사례를 강조 표시합니다.",
      "finish-voting-only-facilitator": "투표 완료(진행자에게만 버튼이 표시됨)",
      "lock-action-plan-only-facilitator": "편집을 완료하기 위한 작업 계획 잠그기(진행자에게만 버튼이 표시됨)",
      "unlock-action-plan-only-facilitator": "편집을 위한 실행 계획 잠금 해제(진행자에게만 버튼이 표시됨)",
      "move-discussion-to-next-case-only-facilitator": "토론을 다음 주제로 이동(진행자에게만 버튼이 표시됨)",
      "remove-discussion-indicator-only-facilitator": "토론 종료(진행자에게만 버튼이 표시됨)",
      "add-new-suggestion": "개발 제안 추가",
      "development-suggestion": "개발 제안",
      "cancel": "취소",
      "send": "보내다",
      "max-3-votes": "최대 투표 수는 3입니다.",
      "action-plan": "행동 계획",
      "owner": "소유자",
      "deadline": "마감 시간",
      "select-owner": "선택하다",
      "edit": "편집하다",
      "delete": "삭제",
      "level": "수준",
      "importance": "중요성",
      "difference": "차이점",
      "votes": "투표",
      "edit-suggestion": "편집하다",
      "show-development-ideas": "시뮬레이션 중 작성된 개발 아이디어를 참가자에게 표시"
    }
  }
</i18n>

<style scoped>
::v-deep .card-body {
  padding: 1rem !important;
}
@media print {
  .noprint {
    display: none !important;
  }
}
::v-deep .btn,
::v-deep button.btn {
  -webkit-tap-highlight-color: transparent !important;
}
::v-deep .btn-outline-primary {
  background-color: white !important;
  background-image: none !important;
  border-color: #FFA500 !important;
  color: #FFA500 !important;
  box-shadow: none !important;
  outline: none !important;
}
::v-deep .btn-outline-primary:active,
::v-deep button.btn-outline-primary:active {
  background-color: rgba(255, 165, 0, 0.1) !important;
  background-image: none !important;
  box-shadow: none !important;
  outline: none !important;
}
::v-deep .btn-outline-primary:focus,
::v-deep button.btn-outline-primary:focus {
  background-color: white !important;
  background-image: none !important;
  box-shadow: 0 0 0 0.2rem rgba(255, 165, 0, 0.35) !important;
  outline: none !important;
}
::v-deep .btn-outline-primary:hover,
::v-deep button.btn-outline-primary:hover {
  background-color: rgba(255, 165, 0, 0.05) !important;
  background-image: none !important;
  box-shadow: none !important;
  outline: none !important;
}
::v-deep .dropdown-menu {
  z-index: 2000 !important;
}
.action-plan-ideas-toggle {
  margin-bottom: 10px;
}
.action-plan-ideas-toggle__label {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 0;
  cursor: pointer;
}
</style>